import { KeySquare, Search } from "lucide-react";
import {
  handleFetchVehicles,
  handleUpdateProgrammed,
} from "../../../api/vehicles";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Button, Input, Popover, message } from "antd";
import { useState } from "react";

export default function Pending() {
  const [keyword, setKeyword] = useState<string>("");
  const queryClient = useQueryClient();
  const { data: vehicles } = useQuery({
    queryKey: ["vehicles", "unprogrammed", keyword],
    queryFn: () => handleFetchVehicles({ state: "unprogrammed", keyword }),
  });

  const { mutate, isPending } = useMutation({
    mutationFn: handleUpdateProgrammed,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["vehicles", "unprogrammed"] });
      queryClient.invalidateQueries({ queryKey: ["vehicles", "programmed"] });
      message.success("Vehicle marked as programmed");
    },
    onError: (error) => {
      message.error(`${error}`);
    },
  });

  const handleMarkAsProgrammed = (vehicle: any) => {
    mutate({ _id: vehicle?._id });
  };

  const content = (
    <div>
      <p>Are you sure you want to mark this vehicle as programmed?</p>
    </div>
  );

  return (
    <div className="">
      <div className="text-center text-gray-500 border-x border-t border-b-4 border-red-300 p-2 bg-red-200">
        <span className="font-bold">{vehicles?.total}</span> Vehicles Not
        Programmed
      </div>
      <div className="p-1 bg-red-100 border border-gray-200">
        <Input
          placeholder="Search Reg Number or VIN Number"
          value={keyword}
          prefix={<Search size={12} className="text-gray-500" />}
          onChange={(e: any) => setKeyword(e.target.value)}
          allowClear
          onPressEnter={(e: any) => setKeyword(e.target.value)}
        />
      </div>
      {vehicles?.records?.map((vehicle: any) => (
        <div
          key={vehicle._id}
          className="flex items-center justify-between border p-1 text-xxs"
        >
          <div>{vehicle.regNumber}</div>
          <div className="flex items-center gap-x-2">
            <div>{vehicle.vinNumber}</div>
            <Popover
              placement="top"
              title={
                <div className="flex items-center gap-x-1">
                  Mark as Programmed :
                  <span className="text-gray-500 text-xs font-bold">
                    ({vehicle.regNumber})
                  </span>
                </div>
              }
              content={content}
            >
              <Button
                type="primary"
                className="bg-red-100 text-red-500"
                size="small"
                onClick={() => handleMarkAsProgrammed(vehicle)}
                disabled={isPending}
              >
                <KeySquare size={12} /> Not Programmed
              </Button>
            </Popover>
          </div>
        </div>
      ))}
    </div>
  );
}
